import React, { useRef } from "react";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useUpdateInitialGroupMutation } from "../../../services/basicData/basicData";
import { InitialGroupForm } from "./InitialGroupForm";
import { useGetOneMakkahGroupQuery } from "../../../services/groups";
import { useSystem } from "@/utils/hooks/useLocation";

const UpdateInitialGroup = () => {
  const { currentSystem } = useSystem();
  /**
   * ==================
   * Hooks
   * ==================
   */
  const { t } = useTranslation();
  const { id, mode } = useParams();
  const formRef = useRef(null);

  /**
   * ==================
   * Queries
   * ==================
   */
  const {
    data: groupRes,
    isLoading: groupLoading,
    isFetching: groupFetching,
    isError: groupError,
  } = useGetOneMakkahGroupQuery();

  /**
   * ==================
   * Mutations
   * ==================
   */
  const { mutate: updateInitialGroup, isPending } =
    useUpdateInitialGroupMutation({
      setError: formRef.current?.setFormError,
    });

  /**
   * ==================
   * Constants
   * ==================
   */
  const canAmend = mode === "edit" || mode === "create";
  const groupData = groupRes?.data?.data;
  const loading = groupLoading || groupFetching;

  /**
   * ==================
   * Handlers
   * ==================
   */
  const onSubmit = (data) => {
    const payload = {
      id: parseInt(id),
      ...data,
    };

    updateInitialGroup(payload, {
      onSuccess: () => formRef.current?.clearDraft?.(),
    });
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (formRef.current?.handleSubmit) {
      formRef.current.handleSubmit(onSubmit)(e);
    }
  };

  /**
   * ==================
   * Render
   * ==================
   */
  if (loading) {
    return (
      <div>
        <PageHeader
          title={
            canAmend ? t("UPDATE_INITIAL_GROUP") : t("INITIAL_GROUP_DETAILS")
          }
        />
        <div className="m-4 text-center py-5">
          <Spinner />
          <p className="mt-3">{t("LOADING")}</p>
        </div>
      </div>
    );
  }

  if (groupError) {
    return (
      <div>
        <PageHeader
          title={
            canAmend ? t("UPDATE_INITIAL_GROUP") : t("INITIAL_GROUP_DETAILS")
          }
        />
        <div className="m-4 text-center py-5">
          <p className="text-danger">{t("ERROR_LOADING_INITIAL_GROUP")}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        backTo={`/app/${currentSystem}/groups-upcoming`}
        title={
          canAmend ? t("UPDATE_INITIAL_GROUP") : t("INITIAL_GROUP_DETAILS")
        }
      />
      <div className="m-4">
        <form onSubmit={handleFormSubmit} className="d-flex flex-column gap-4">
          <InitialGroupForm
            ref={formRef}
            initialData={{
              ...groupData,
              nationality: +groupData.nationality,
              organizer_country: +groupData.organizer_country,
              delegation: groupData.delegation ? String(groupData.delegation) : null,
              affiliated_organizer: groupData.affiliated_organizer ? String(groupData.affiliated_organizer) : null,

            }}
            canAmend={canAmend}
          />

          {canAmend && (
            <div>
              <Button
                variant="primary"
                type="submit"
                onClick={() => { }}
                disabled={isPending}
              >
                {isPending && <Spinner size="sm" className="me-2" />}
                {t("UPDATE_INITIAL_GROUP")}
              </Button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default UpdateInitialGroup;
